import React, {useRef , useEffect, useState ,Fragment} from 'react'
import {Link } from 'react-router-dom'

const Home = () => {

    const refWolverine = useRef(null);
    const [btn,setBtn]= useState(false);
/******* au moment du montage */
    useEffect(() => {
        refWolverine.current.classList.add("startingImg");
        setTimeout(() => {
            refWolverine.current.classList.remove("startingImg");
            setBtn(true);
        },1000);

        
    },[])

const setLeftImg =() =>{
    refWolverine.current.classList.add("leftImg");
};
const setRightImg =() =>{
    refWolverine.current.classList.add("rightImg");
}
const clearImg = () => {
    if(refWolverine.current.classList.contains("leftImg")){
        refWolverine.current.classList.remove("leftImg");

    }else if(refWolverine.current.classList.contains("rightImg")){
        refWolverine.current.classList.remove("rightImg");
    }
}

    const DisplayBtn = btn && (
        <Fragment>
            <div  onMouseOver={setLeftImg} onMouseOut={clearImg} className="leftBox">
                <Link className="btn-welcome" to="/signup">Inscription</Link>
            </div>
            <div onMouseOver={setRightImg} onMouseOut={clearImg} className="rightBox">
                <Link className="btn-welcome" to="/login">Connexion</Link>
            </div>
        </Fragment>

    )
    return (
        <main ref={refWolverine} className="welcomePage">
            {DisplayBtn}
            

        </main>
    )
}

export default Home
